import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow, parseDateTime } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { buildUpgradeUrl } from './utils';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';
export const shouldRender = (data) => {
    const { isCompanyAccount, companiesTrialEndDate } = data.currentAccount;
    if (!companiesTrialEndDate || isCompanyAccount)
        return false;
    const companiesTrialHasEnded = parseDateTime(companiesTrialEndDate) < new Date();
    return companiesTrialHasEnded && daysFromNow(companiesTrialEndDate) <= 7;
};
export const Component = function CompaniesTrialEnded(props) {
    var _a;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data } = props;
    const { currentAccount } = data;
    const upgradeUrl = buildUpgradeUrl({
        currentPlanName: currentAccount.plan.name,
        upgradePlanName: (_a = data.nextCompanyPlan) === null || _a === void 0 ? void 0 : _a.name,
        interval: currentAccount.plan.interval,
    });
    const onUpgrade = () => {
        props.trackEvent('company-trial-ended-upgrade-clicked', {
            profileId: data.currentUser.customUserId,
        });
    };
    const onContactSupport = () => {
        props.trackEvent('company-trial-ended-support-extend-trial-clicked', {
            profileId: data.currentUser.customUserId,
        });
    };
    return (isolateComponent(Alert, { layout: props.layout, title: "Your Company trial has ended", type: "info" },
        isolateComponent(Link, { href: getFullyQualifiedURL(upgradeUrl), onClick: onUpgrade }, "Upgrade"),
        ' ',
        "to keep using our advanced administrative and security controls. Still have questions?",
        ' ',
        isolateComponent(Link, { href: getFullyQualifiedURL('/app/get-help'), onClick: onContactSupport }, "Contact us"),
        ' '));
};
//# sourceMappingURL=CompaniesTrialEnded.js.map
// @zapier/universal-layout@8.6.23 (c29ded5a6)
